import { Link } from "react-router-dom";
import { useInView } from "react-intersection-observer";
import { URL_BACKEND } from "../../utils/const";
import { addSpaceToNumber } from "../../utils/utils";

// Приводим возможные "2 728,53" → 2728.53
const toNum = (v) => {
  if (typeof v === "number") return v;
  const s = String(v)
    .replace(/\s/g, "")      // убираем пробелы/неразрывные
    .replace(",", ".")       // запятую → точку
    .replace(/[^\d.-]/g, ""); // лишние символы
  const n = Number(s);
  return Number.isFinite(n) ? n : 0;
};

const ItemHelpNeed = ({ item }) => {
  const [ref] = useInView({ triggerOnce: true, rootMargin: "-100px 0px" });
  const cls = ["article-item"];

  // «Сырые» значения оставляем для красивого отображения,
  // а для расчётов приводим к числам:
  const moneyRaw = item.money;
  const needRaw = item.moneyneed;
  const money = toNum(moneyRaw);
  const need = toNum(needRaw);

  const pctFloat = need > 0 ? (money * 100) / need : 0;
  const pct = Math.max(0, Math.min(100, Math.round(pctFloat))); // clamp 0..100

  return (
    <div ref={ref} className={cls.join(" ")}>
      <Link to={`/profile/${item.slug}`}>
        {item.image && (
          <div
            className="article-item__img"
            style={{ backgroundImage: `url("${URL_BACKEND + item.image}")` }}
          ></div>
        )}
      </Link>

      <div className="article-item__text">
        <div className="article-item__title">
          <h2>{item.fio}</h2>
        </div>

        <div className="article-item__description">
          {item.dia && (
            <p className="article-item__description-diagnosis">
              Диагноз: {item.dia}
            </p>
          )}
          {item.short && (
            <p className="article-item__description-text">{item.short}</p>
          )}
        </div>
      </div>

      <div className="article-item__footer">
        {item.status === 1 && (
          <div className="article-item__money">
            <span>
              <p
                className="article-item__money-recd-wrap"
                title={`${pct}%`} // подсказка с процентом при наведении
              >
                <span className="article-item__money-recd">
                  {addSpaceToNumber(String(moneyRaw))}
                </span>{" "}
                ₽
              </p>
              <p className="article-item__money-progress">{pct}%</p>
              <p>СОБРАНО</p>
            </span>

            <span>
              <p>
                <span className="article-item__money-need">
                  {addSpaceToNumber(String(needRaw))}
                </span>{" "}
                ₽
              </p>
              <p>НУЖНО</p>
            </span>

            <div
              className="article-item__progress-bar"
              style={{ width: `${pct}%` }}
            ></div>
          </div>
        )}

        <div className="article-item-buttons">
          <Link to={`/profile/${item.slug}`}>
            <div className="article-btn-details btn btn-primary">Подробнее</div>
          </Link>

          {item.status === 1 ? (
            <a
              href={
                item.payment_link
                  ? item.payment_link
                  : "https://securecardpayment.ru/sc/PvQptRkqJPEiXVbL"
              }
            >
              <div className="article-donate btn btn-primary">Помочь</div>
            </a>
          ) : (
            <div>
              <div className="article-donate btn btn-primary">
                Помощь оказана
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ItemHelpNeed;
